import { Button } from "@/components/ui/button";
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useWorkspaceStore } from "@/store/workspace-store";
import { AlertCircle } from "lucide-react";

/**
 * Shown when workspaces fail to load — usually the API being down — so the
 * user sees a way out instead of a spinner that never ends.
 */
export function WorkspaceLoadError() {
  const { initializeWorkspaces, isInitializing } = useWorkspaceStore();

  const handleRetry = () => {
    initializeWorkspaces().catch(() => {
      // The store keeps the error; this screen stays up.
    });
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <Card className="w-full max-w-md m-2">
        <CardHeader>
          <div className="flex items-center gap-2 text-red-600 mb-2">
            <AlertCircle className="h-5 w-5" />
            <span className="text-sm font-medium">Connection problem</span>
          </div>
          <CardTitle>We couldn't load your workspaces</CardTitle>
          <CardDescription>
            Our servers aren't responding right now. Your data is safe — try
            again in a moment.
          </CardDescription>
        </CardHeader>
        <CardFooter>
          <Button onClick={handleRetry} disabled={isInitializing}>
            {isInitializing ? "Retrying…" : "Try again"}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
